import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

function Login() {
  const navigate = useNavigate();

  const [shop, setShop] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [setupRequired, setSetupRequired] = useState(false);

  useEffect(() => {
    const fetchShop = async () => {
      try {
        const res = await axios.get(`${API_URL}/shop`);
        setShop(res.data);
        const setupRes = await axios.get(`${API_URL}/auth/setup-status`);
        setSetupRequired(setupRes.data.setupRequired);
      } catch (error) {
        setShop({
          shopName: "MJ UNIQUE VENTURES LTD",
        });
        setSetupRequired(true);
      }
    };

    fetchShop();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(`${API_URL}/auth/login`, {
        email,
        password,
      });

      localStorage.setItem("token", res.data.token);

      navigate("/");
    } catch (error) {
      setMessage(error.response?.data?.message || "Login failed.");
    }
  };

  return (
    <div style={styles.page}>
      <form onSubmit={handleLogin} style={styles.card}>
        <div style={styles.brandBox}>
          <h1 style={styles.shopName}>{shop?.shopName || "MJ UNIQUE VENTURES LTD"}</h1>
          <p style={styles.subtitle}>Sign in to continue</p>
        </div>

        {message && <p style={styles.message}>{message}</p>}

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
          required
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
          required
        />

        <button type="submit" style={styles.button}>
          Login
        </button>

        {setupRequired && (
          <button
            type="button"
            onClick={() => navigate("/setup-owner")}
            style={styles.secondaryButton}
          >
            Create Owner Account
          </button>
        )}
      </form>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "#f4f6f8",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Arial, sans-serif",
  },

  card: {
    width: "380px",
    background: "white",
    padding: "28px",
    borderRadius: "16px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
  },

  brandBox: {
    textAlign: "center",
    marginBottom: "22px",
  },

  shopName: {
    margin: 0,
    fontSize: "28px",
  },

  subtitle: {
    margin: "8px 0 0",
    color: "#555",
  },

  input: {
    width: "100%",
    padding: "14px",
    marginBottom: "12px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },

  button: {
    width: "100%",
    padding: "14px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "bold",
  },

  message: {
    padding: "10px",
    background: "#fff3cd",
    borderRadius: "8px",
    marginBottom: "12px",
  },
  secondaryButton: {
    width: "100%",
    padding: "14px",
    marginTop: "10px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "16px",
    background: "white",
  },
};

export default Login;